import axios from 'axios'

const request = axios.create({
  baseURL: 'http://mhrtest.huarendjk.com/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
})

// 添加请求拦截器
request.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log('req err', error)
    let errMsg = ''
    if (error.message) errMsg = error.message
    else errMsg = '请求失败'
    alert(errMsg)
    return Promise.reject(error)
  },
)

// 添加响应拦截器
request.interceptors.response.use(
  res => {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么
    const code = res.data.code
    let msg = res.data.msg

    if (code === 0) {
      return res.data.data
    } else {
      alert(msg)
      return Promise.reject(res.data)
    }
  },
  error => {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    let errMsg = ''
    // 如果是取消请求，就不弹窗，此时接口的 then 会收到 undefined，例如 loginAPI().then(res => {})，res 为 undefined
    if (error.message == 'canceled') return
    if (error.message) errMsg = error.message
    else errMsg = '系统错误'
    alert(errMsg)
    return Promise.reject(error)
  },
)

export default request
